import React, { useState, useEffect } from "react";
import { CSVLink } from "react-csv";

export default function ExportToExcle(props) {
  const { Data, ReportName, DynamicReports, listOfColKey, criteriaString } = props;

  console.log('listOfColKey :>> ', listOfColKey);
  console.log('Data :>> ', Data);
  const [ExportData, setExportData] = useState({
    dataExport: "",
  });

  const changeHandler = () => {
    const criteriaRow = {
      [listOfColKey?.[0]?.value || "Note"]:
        props.criteriaString || "Filter: N/A",
    };
    const emptyRow = {}; // optional empty row between criteria and data

    const combinedData = [criteriaRow, emptyRow, ...Data];

    setExportData({ dataExport: combinedData });
  };

  const data = ExportData.dataExport;

  let headers = [
    { label: " ", key: "invoiceDate" },
    { label: " ", key: "INVOICE_REF_NO" },
    { label: " ", key: "invoiceDueDate" },
    { label: " ", key: "payments" },
    { label: " ", key: "invoiceAmount" },
    { label: " ", key: "total" },
  ];
  if (DynamicReports) {
    let newHeaders = [];
    for (let index = 0; index < listOfColKey?.length; index++) {
      const elementKey = listOfColKey[index].value;
      newHeaders.push({ label: ` `, key: `${elementKey}` });
    }

    headers = newHeaders;
  }

  const csvReport = {
    filename: `${ReportName} .csv`,
    headers: headers,
    data: data,
  };

  return (
    <>
      <div>
        <CSVLink
          {...csvReport}
          onClick={changeHandler}
          className="btn btn-primary"
        >
          Export To Excel
        </CSVLink>
      </div>
    </>
  );
}
